module.exports = __webpack_public_path__ + "assets/img/qrcode.6149308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/desiagner/qrcode.png
// module id = eHlB
// module chunks = 1